module.exports = __webpack_public_path__ + "2f3ea313abd81c9dc907e66674c58b01.svg";